var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"/logos/ia/chatbot.svg","title":_vm.$t('app.icons.chat_bot'),"aria-label":_vm.$t('app.icons.chat_bot')}})}
var staticRenderFns = []

export { render, staticRenderFns }